import { memo, forwardRef } from 'react';
import { MenuItem, type SelectProps } from '@mui/material';
import { Select } from 'components/mui/common/Select';
import type { RadioButtonFormItem } from '../../../../../types';
import type { FormItemUiDefinition } from 'types/formItem';

type Props = SelectProps & {
  value: string;
  items?: RadioButtonFormItem['items'];
  disabled?: boolean;
  isClickable?: boolean;
  helperText?: string;
  background?: 'white' | 'transparent';
  formItemUiDefinition?: FormItemUiDefinition;
};

interface OptionItem {
  label: string;
  val: string;
  id: string;
}

const SelectEditableBase = forwardRef<HTMLSelectElement, Props>(
  ({ value, disabled, items, error, helperText, formItemUiDefinition, ...field }, ref) => {
    const transformItemToOption = ({ name }: { name: string }) => ({
      label: name,
      val: name,
      id: name,
    });

    const transformedItems = (items ?? []).map(transformItemToOption);

    return (
      <Select
        {...field}
        ref={ref}
        value={value}
        disabled={disabled}
        error={Boolean(error)}
        helperText={helperText}
        formItemUiDefinition={formItemUiDefinition}
        displayEmpty>
        {transformedItems.map(({ label, val, id }: OptionItem) => (
          <MenuItem key={id} value={val}>
            {label}
          </MenuItem>
        ))}
      </Select>
    );
  }
);

export const SelectEditable = memo(SelectEditableBase) as typeof SelectEditableBase;
